import React, { FC } from 'react'
import styled from 'styled-components'
import { BuffetProductDetailQuery } from 'graphQL/dinein/generate/operations'
import { Fonts, LabelBox } from 'components/base-ui'
import useLanguage from 'hooks/useLanguage'
import ProductPrice from 'components/base-ui/ProductPrice'
import { useTranslation } from 'react-i18next'
import { BuffetProductTypeEnum } from './ProductDetail'
import { LabelMedium, HeadLineLarge } from 'components/base-ui/FontsV2'

export type BuffetProduct = BuffetProductDetailQuery['product']

type Props = {
  product: BuffetProduct
  packages: string[]
  buffetProductType: BuffetProductTypeEnum
}

const TitleSection: FC<Props> = ({ product, packages, buffetProductType }) => {
  const { getPropertyByLang } = useLanguage()
  const { t } = useTranslation()
  return (
    <>
      {buffetProductType === BuffetProductTypeEnum.ExcludedPackage ? (
        <>
          <LabelMedium>{packages[0]}</LabelMedium>
          <HeadLineLarge>
            {getPropertyByLang({
              th: String(product.nameTh),
              en: String(product.nameEn),
            })}
          </HeadLineLarge>
        </>
      ) : buffetProductType === BuffetProductTypeEnum.ALaCarte ? (
        <>
          <Label>
            <Fonts.BaseTitleRegular>{t('buffet.label.alarcarte')}</Fonts.BaseTitleRegular>
          </Label>
          <Fonts.H2>
            {getPropertyByLang({
              th: String(product.nameTh),
              en: String(product.nameEn),
            })}
          </Fonts.H2>
          <ProductPrice
            customClassName="product-price"
            totalPrice={product.totalPriceSatangs}
            discount={product.discountSatangs}
            priceBeforeDiscount={product.priceSatangs}
          />
          <LabelBox style={{ width: '100%' }} title={t('buffet.warning.alacarte')} text="" type="warning" />
        </>
      ) : (
        <Fonts.H2>
          {getPropertyByLang({
            th: String(product.nameTh),
            en: String(product.nameEn),
          })}
        </Fonts.H2>
      )}
    </>
  )
}

export default TitleSection

const Label = styled.div`
  color: ${({ theme }) => theme.colors.white};
  background: ${({ theme }) => theme.colors.primary};
  border-radius: 20px;
  padding: 2px 8px;
`
